import { gql } from '@apollo/client';

export const GET_WAREHOUSE_BY_ZIPCODE = gql`
    query GetWarehouseByZipcode($zipcode: String!) {
        getWarehouseByZipcode(zipcode: $zipcode) {
            id
            name
            siteType
            addressLine1
            addressLine2
            city
            state
            zipcode
            country
            pickupZoneZipcodeList
            pickupDeadlineTime
            appointmentDeadlineTime
        }
    }
`;

export interface WarehouseByZipcodeData {
    getWarehouseByZipcode: Array<{
        id: string;
        name: string;
        siteType: string;
        addressLine1?: string;
        addressLine2?: string;
        city?: string;
        state?: string;
        zipcode?: string;
        country?: string;
        pickupZoneZipcodeList: string[];
        pickupDeadlineTime?: string;
        appointmentDeadlineTime?: string;
    }>;
}

export interface WarehouseByZipcodeVariables {
    zipcode: string;
}
